<template>
  <div class="page_collect">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>知识库</el-breadcrumb-item>
          <el-breadcrumb-item>公司宣传资料</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="importFile" v-if="checkPermission(['upload'], permissionLists)">上传文件</el-button>
        </div>
        <div style="width:601px">
          <el-table :data="tableData" border class="doc_table" v-loading="loading">
            <el-table-column prop="creationTime" label="文件" min-width="300" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span class="blueName cp" @click="down(row)">{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="creationTime" label="创建时间" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.creationTime ? row.creationTime.replace('T', ' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="down(row)">下载</el-button>
                  <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="checkPermission(['del'], permissionLists)">
                    <el-button type="text" slot="reference">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="上传文件" :visible.sync="showImport" width="500px">
      <el-form :model="impForm" ref="impForm" label-width="80px">
        <el-form-item label="上传文件:" prop="url">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" :loading="isUpLoading" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="confirmImport" :disabled="!this.impForm.url" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          start: '',
          end: '',
          type: 2,
          pagination: {
            pageSize: 10,
            page: 1,
            orders: [{
              property: 'Name',
              order: 0
            }]
          },
        },
        showDropScreen: -1,
        tableData: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        isBtnLoading: false,
        showImport: false,
        fileList: [],
        isUpLoading: false,
        permissionLists: [],
        impForm: {
          name: '',
          url: '',
          type: 2,
          founder: Cookies.get("userid-b"),
          extension: '', //扩展名
        },
      }
    },
    created() {
      this.getButtonPower();
      this.getList();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/companyMaterials',
          powerEnName: 'companyMaterials'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.pagination.pageSize = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pagination.page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pagination.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.SRFun(this.listQuery, 'GetBiddingMaterialsList').then(res => {
          if (res.status == 'ok' && res.data.data != null) {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 上传大文件
      success_handle(file) {
        this.isUpLoading = true
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadMaxFile(formData).then((res) => {
          if (res) {
            this.impForm.url = res;
            this.impForm.name = file.name;
            this.impForm.extension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);;
            this.isUpLoading = false;
          } else {
            this.impForm.url = '';
            this.impForm.name = '';
            this.isUpLoading = false;
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多导入 1 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.impForm.url = '';
      },
      importFile() {
        this.impForm = {
          name: '',
          url: '',
          type: 2,
          founder: Cookies.get("userid-b"),
          extension: '', //扩展名
        }
        this.fileList = [];
        this.isBtnLoading = false;
        this.showImport = true;
      },
      confirmImport() {
        if (this.impForm.url) {
          this.isBtnLoading = true;
          xz.SRFun(this.impForm, 'PostBiddingMaterialsSave').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.showImport = false;
              this.isBtnLoading = false;
              this.$message.success('保存成功！');
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请上传文件')
        }
      },
      del(row) {
        this.loading = true;
        let str = `SetBiddingMaterialsDelete?FileId=${row.fileId}`;
        xz.SRGetFun(str, 'DELETE').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success('删除成功！');
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      down(row) {
        var path = this.$store.state.EMP.tablePath + row.url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', row.name);
        aTag.click();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .errTips {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_collect .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_collect .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_collect .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_collect .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_collect .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_collect .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>